function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "139",
  height: "112"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M123.333 42.393h-.044l-25.081 10.73L63.89 67.804a1.108 1.108 0 01-.848.005L27.638 53.092 1.94 42.411l-.04-.018h-.043a1.533 1.533 0 00-1.53 1.532v66.543c0 .846.686 1.531 1.53 1.532h121.476c.844 0 1.53-.686 1.53-1.532V43.925c0-.845-.686-1.531-1.53-1.532"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M123.442 42.831a.217.217 0 01-.124-.039L62.894.632a1.096 1.096 0 00-1.251.003L1.655 42.791a.218.218 0 11-.251-.358L61.392.277a1.53 1.53 0 011.752-.003l60.423 42.158a.219.219 0 01-.125.399"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6E6",
  d: "M5.082 44.325L62.327 1.821l57.68 45.529-54.73 32.505-29.714-6.786z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M38.072 99.932H9.792a1.324 1.324 0 01-.004-2.648h28.284a1.323 1.323 0 01.003 2.648h-.003zM19.937 94.24H9.791a1.324 1.324 0 01-.003-2.647h10.15c.73 0 1.322.59 1.322 1.322a1.322 1.322 0 01-1.318 1.326h-.005z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M63.132 68c-.214 0-.428-.042-.626-.123L27.2 53.2V7.26a1.532 1.532 0 011.53-1.532h67.73a1.534 1.534 0 011.53 1.533v45.97l-.067.029-34.145 14.61c-.204.086-.424.13-.646.13"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M27.528 52.981l35.103 14.593c.327.133.693.13 1.02-.006l34.01-14.552V7.262c0-.665-.538-1.204-1.201-1.204H28.73c-.663 0-1.2.539-1.202 1.204v45.72zM63.132 68.11c-.229 0-.456-.044-.668-.13L27.092 53.273V7.262c0-.907.734-1.641 1.638-1.642h67.73c.905 0 1.637.735 1.639 1.642v46.043L63.82 67.97c-.218.092-.452.14-.689.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M124.098 110.468c0 .604-.49 1.094-1.092 1.094H1.529c-.603 0-1.092-.49-1.092-1.094V43.926c0-.588.464-1.071 1.05-1.095L27.31 53.565l35.237 14.649c.381.155.809.152 1.188-.007L97.88 53.598l25.169-10.767a1.098 1.098 0 011.049 1.095v66.542zm-1.092-68.075h-.044L97.88 53.123 63.563 67.804c-.27.114-.576.116-.848.004L27.31 53.093 1.612 42.41l-.039-.018H1.53A1.534 1.534 0 000 43.926v66.542c0 .846.685 1.531 1.53 1.532h121.476a1.53 1.53 0 001.529-1.532V43.926c0-.846-.685-1.532-1.53-1.533z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M57.636 22.901H33.603a1.749 1.749 0 01-1.745-1.753 1.75 1.75 0 011.745-1.749h24.033a1.75 1.75 0 010 3.502M45.183 15.46h-11.58c-.965 0-1.748-.785-1.748-1.752s.783-1.751 1.748-1.751h11.58c.965 0 1.747.784 1.747 1.751 0 .967-.782 1.751-1.747 1.751"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M80.57 40.413H43.865a1.75 1.75 0 01-1.744-1.755 1.75 1.75 0 011.744-1.748H80.57a1.75 1.75 0 010 3.503m0 8.099H43.865a1.75 1.75 0 01-1.748-1.752c0-.967.783-1.75 1.748-1.75H80.57c.965 0 1.748.783 1.748 1.75a1.75 1.75 0 01-1.748 1.752"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E69342",
  d: "M122.38 26.328c9.179 0 16.62 7.454 16.62 16.65 0 9.196-7.441 16.651-16.62 16.651-9.179 0-16.62-7.455-16.62-16.65 0-9.197 7.441-16.651 16.62-16.651"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "3",
  d: "M116.568 43.953l3.149 3.282 8.173-8.518"
})));